import { UUID } from 'angular2-uuid';
import { OnepageFieldOption } from './onepage-template-field';


export class DeploymentProductInfo {
    id: string;
    productCode: string;
    productName: string;
    merCode: string;
    quota: number;
    quotaLeft: number;
    relatingButtonFieldOption: OnepageFieldOption;
    relatingButtonFieldId: string;

    _uiFlagId: string;
    constructor() {
        this._uiFlagId = UUID.UUID();
    } 

    static search(term: string, item: DeploymentProductInfo) {
        term = term.toLocaleLowerCase();
        return  item.productCode.toLocaleLowerCase().indexOf(term) > -1;
    }
}

